var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-number',{attrs:{"mode":"auto","from":_vm.from,"to":_vm.to,"duration":4000,"easing":"easeOutQuad"}})}
var staticRenderFns = []

export { render, staticRenderFns }